import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';


const Navbar = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('isDemo'); 
        navigate('/landing');
    };

    return (
        <nav className="navbar">
            <div className="navbar-content">
                <Link to="/" className="navbar-brand">
                    AI Todo list
                </Link>

                <div className="navbar-user">
                    <span className="navbar-username">
                        {user?.username}
                    </span>
                    <button 
                        onClick={handleLogout} 
                        className="navbar-logout"
                    >
                        Logout
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
